module.exports = __webpack_public_path__ + "static/curious-09bd727f44beafa3fae5c1c088676c7a.svg";